import { Outlet, Link } from "react-router-dom";

const Layout = () => {
  
  return (
    <>
      <nav >
        <ul className="nav nav-tabs">
          
          <li className="nav-item">
            <Link to="/blogs"  className="nav-link">Blogs</Link>
          </li>
          <li  className="nav-item">
            <Link to="/contact" className="nav-link">Contact</Link>
          </li>
          
        </ul>
      </nav>

      <Outlet />
    </>
  )
};

export default Layout;
